<template>
    <div id="monitor-table-page">
        <div class="monitor-table-page__header">
            <h2>{{ default_name }}資訊</h2>
            <MonitorOptionSet
                class="monitor-table-page__option"
                :option_set="option_set"
                ref="monitor_option_set"
                @filter_data="filter_data"
            />
        </div>
        <Rainfall
            :activate_filter_by_parent="true"
            :filter_value_from_parent="filtered_port"
            @collect_data="collect_data"
        />
        <SurfaceWeather
            :activate_filter_by_parent="true"
            :filter_value_from_parent="filtered_port"
            @collect_data="collect_data"
        />
        <Buoy
            :default_value="202"
            :activate_filter_by_parent="true"
            :filter_value_from_parent="filtered_port"
            @collect_data="collect_data"
        />
        <Tide
            :default_value="205"
            :activate_filter_by_parent="true"
            :filter_value_from_parent="filtered_port"
            @collect_data="collect_data"
        />
    </div>
</template>

<script>
    import {
        update_option_set_from_local_storage,
        update_current_option_value,
    } from '@/utils/monitor/option.js'
    import Rainfall from "@/components/monitor/common/rainfall.vue"
    import SurfaceWeather from "@/components/monitor/common/surface_weather.vue"
    import Buoy from "@/components/monitor/common/buoy.vue"
    import Tide from "@/components/monitor/common/tide.vue"

    export default {
        name: 'PortMonitor',
        
        components: {
            Rainfall,
            SurfaceWeather,
            Buoy,
            Tide,
            MonitorOptionSet: () => import('@/components/monitor/monitor_option_set.vue'), 
        },

        data() {
            return {
                default_name: '港口監測項目',
                all_immutable_data: [],
                
                option_set: [
                    { 
                        current_option_value: '所有港口', 
                        json_key: '轄管區', 
                        label: 'port',
                        option_array: ['所有港口']
                    }
                ],
                display_all_port: '所有港口',

                filtered_port: '',
                local_storage_option_name: 'port_monitor_option',
            }
        },

        watch: {
            all_immutable_data: {
                handler(){
                    this.generate_option_set()
                    this.option_set = update_option_set_from_local_storage(this.option_set , this.local_storage_option_name)
                },
                deep: true
            },
        },
        
        methods: {
            collect_data(data_from_child) {
                this.all_immutable_data = [...this.all_immutable_data, ...data_from_child]
            },

            generate_option_set() {
                const new_port_option = this.all_immutable_data
                    .map(datum => datum['轄管區'])
                    .filter(datum => datum)

                this.$set(this.option_set[0], 'option_array', [this.display_all_port, ...new Set(new_port_option)])
                
                if(!new_port_option.includes(this.option_set[0].current_option_value)){
                    this.$set(this.option_set[0], 'current_option_value', this.display_all_port)
                }
                this.option_set.length !== 0 && this.$refs.monitor_option_set.change_option_set()
            },

            filter_data(filtered_condition) {
                const update_current_value_by_filtered_condition = update_current_option_value(filtered_condition)
                this.option_set = this.option_set.map(update_current_value_by_filtered_condition)
                this.filtered_port = filtered_condition['port']
                
                localStorage.setItem(this.local_storage_option_name, JSON.stringify(filtered_condition))
            },
        },
    }
</script>

<style lang="scss" scoped>
    h2 {
        font-size: 20px;
    }

    .monitor-table-page {
        &__header {
            display: flex;
            align-items: center;
            gap: 1rem;
            padding: 0 1rem;
            border-bottom: 1px solid var(--grey-border);
        }

        &__option {
            margin-bottom: 1rem;
        }
    }
</style>